<div class="statistics" id="statistics-section">
  <div class="statistics--container">
    <div class="statistics--card">
      <div class="stat--item" *ngFor="let stat of stats">
        <div class="stat--icon">
          <img [src]="stat.icon" [alt]="stat.label + ' icon'" />
        </div>
        <div class="stat--content">
          <div class="stat--number">{{ stat.displayValue | number: '1.0-0' }}</div>
          <div class="stat--label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

